export interface RankTier {
  id: string;
  name: string;
  minAura: number;
  maxAura: number; // inclusive or Infinity
  badge: string;
}

export const RANK_TIERS: RankTier[] = [
  { id: 'npc_3', name: 'NPC III', minAura: 0, maxAura: 499, badge: '💤' },
  { id: 'npc_2', name: 'NPC II', minAura: 500, maxAura: 999, badge: '👀' },
  { id: 'npc_1', name: 'NPC I', minAura: 1000, maxAura: 1999, badge: '🤖' },
  { id: 'apprentice', name: 'Aura Apprentice', minAura: 2000, maxAura: 3499, badge: '⚡' },
  { id: 'farmer', name: 'Aura Farmer', minAura: 3500, maxAura: 5499, badge: '🌾' },
  { id: 'demon', name: 'Aura Demon', minAura: 5500, maxAura: 7999, badge: '😈' },
  { id: 'lord', name: 'Aura Lord', minAura: 8000, maxAura: 11999, badge: '⚡' },
  { id: 'mythic', name: 'Mythic Aura', minAura: 12000, maxAura: Infinity, badge: '👑' },
];

export interface RankInfo {
  tier: RankTier;
  currentAura: number;
  nextTier: RankTier | null;
  auraToNext: number;
  progressPercent: number; // 0 to 100
  displayText: string;
}

export function getRankInfo(aura: number): RankInfo {
  const currentAura = Math.max(0, Math.floor(aura));

  let currentTier = RANK_TIERS[0];
  let nextTier: RankTier | null = RANK_TIERS[1];

  for (let i = 0; i < RANK_TIERS.length; i++) {
    const tier = RANK_TIERS[i];
    if (currentAura >= tier.minAura) {
      currentTier = tier;
      nextTier = i < RANK_TIERS.length - 1 ? RANK_TIERS[i + 1] : null;
    }
  }

  let auraToNext = 0;
  let progressPercent = 100;

  if (nextTier) {
    const range = nextTier.minAura - currentTier.minAura;
    const gained = currentAura - currentTier.minAura;
    progressPercent = Math.min(100, Math.max(0, Math.round((gained / range) * 100)));
    auraToNext = nextTier.minAura - currentAura;
  }

  const displayText = nextTier
    ? `${auraToNext.toLocaleString()} Aura until ${nextTier.name}`
    : 'MAX RANK ACHIEVED';

  return {
    tier: currentTier,
    currentAura,
    nextTier,
    auraToNext,
    progressPercent,
    displayText,
  };
}

export function calculateAuraGain(score: number, perfects: number, greats: number, maxCombo: number, isWin?: boolean): number {
  // Base formula rewarding precision and streaks
  let gain = Math.round(score / 75 + perfects * 4 + greats * 2 + maxCombo * 3);
  if (isWin === true) {
    gain += 75; // Competitive win bonus
  } else if (isWin === false) {
    gain = Math.max(10, Math.round(gain * 0.4)); // Consolation aura
  }
  return Math.max(5, gain);
}
